import { useState } from 'react'

import createStorage from './create-storage'
import usePersistedState from './use-persisted-state'
import { webStorageProvider } from '../storage-providers'

const createPersistedState = (key, provider = webStorageProvider) => {
  if (provider) {
    const storage = createStorage(provider)
    return initialState => usePersistedState(initialState, key, storage)
  }
  return useState
}

export default createPersistedState
